<template>
  <div class="auth-user-info">
    <strong>{{ fullName }}</strong>
    <span>Rut: {{ user.claveunica_id }} | {{ userRoleName }}</span>
    <span v-if="user.logs.length > 0">Última actividad: {{lastActivity}}</span>
    <span><a style="text-decoration: underline;cursor:pointer;" v-on:click="viewLogs = true">Ver detalles</a></span>
  
    <el-dialog
      title="Últimas actividades"
      width="60%"
      :before-close="handleCloseLogs"
      custom-class="medication-request-form__dialog"
      :visible="viewLogs">

      <table class = "table">
        <thead>
          <tr>
            <th>Tipo de acceso</th>
            <th>IP</th>
            <th>Fecha y hora</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in user.logs" :key="log.id">
            <td style="max-width:400px;">{{getBrowser(log.user_agent)}}</td>
            <td>{{log.ip}}</td>
            <td>{{log.created_at.split(' ').join(' a las ')}}</td>
          </tr>
        </tbody>
      </table>

    </el-dialog>
  </div>
</template>

<script>
import userTypes from '@/assets/constants/user-roles';

export default {
  name: 'AuthUserInfo',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      viewLogs : false
    }
  },
  computed: {
    fullName() {
      return `${this.user.given_name} ${this.user.family_name}`;
    },
    position() {
      return this.user.position || 'Cargo no informado';
    },
    userRoleName() {
      return userTypes.find(t => t.type === this.user.type).name;
    },
    qualification() {
      return this.user.qualification;
    },
    lastActivity(){
      let last = (this.user.logs.length == 1) ? this.user.logs[0] : (this.user.logs[1]);
      return last.created_at.split(' ').join(' a las ');

    }
  },
  methods : {
    handleCloseLogs(){
      this.viewLogs = false;
    },
    getBrowser(user_agent){

      //Descartando safari primero

      if (user_agent.includes('Safari') && !user_agent.includes('Chrome')){
        return 'Safari';
      }

      //Descartando opera

      if (user_agent.includes('OPR/')){
        return 'Opera';
      }

      //Firefox
      if (user_agent.includes('Firefox')){
        return 'Firefox';
      }

      //Edge
      if (user_agent.includes('Edg/') || user_agent.includes('Edge/')){
        return 'Edge';
      }

      //Internet Explorer
      if (user_agent.includes('Trident')){
        return 'Internet Explorer'
      }

      //Chrome
      if (user_agent.includes('Chrome')){
        return 'Chrome';
      }

      return 'Navegador desconocido';
    }
  }
};
</script>

<style lang="scss">
.auth-user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  strong {
    line-height: 1.2;
    font-size: $--font-size-md;
  }

  span {
    font-size: $--font-size-sm;
  }
}
</style>
